import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { formatProductCodes } from '../../../utils/productCodes.utils';
import useProductDetailsScrollHeader from '../../hooks/useProductDetailsScrollHeader';
import ProductDetailsCloseButton from '../ProductDetailsCloseButton';
import { useProductDetailsScrollHeaderStyles } from './productDetailsScrollHeader.styles';

interface ProductDetailsScrollHeaderProps {
  name: string;
  code: string;
  referenceCode?: string;
  titleElement: HTMLElement | null;
  scrollElement: HTMLElement | null;
  onClose: () => void;
}

const ProductDetailsScrollHeader = ({
  name,
  code,
  referenceCode,
  titleElement,
  scrollElement,
  onClose,
}: ProductDetailsScrollHeaderProps) => {
  const { classes, cx } = useProductDetailsScrollHeaderStyles();
  const isVisible = useProductDetailsScrollHeader({ titleElement, scrollElement });

  const codes = formatProductCodes({ code, referenceCode });

  return (
    <div className={classes.rail}>
      <Stack
        direction="row"
        alignItems="center"
        gap={1.25}
        className={cx(classes.bar, isVisible && classes.barVisible)}
      >
        <Typography noWrap variant="body1" color="textPrimary" sx={{ minWidth: 0 }} title={name}>
          {name}
        </Typography>

        <Typography
          noWrap
          variant="micro1"
          color="text.secondary"
          title={codes}
          sx={{ flex: 1, minWidth: 0 }}
        >
          {codes}
        </Typography>

        <ProductDetailsCloseButton onClick={onClose} />
      </Stack>
    </div>
  );
};

export default ProductDetailsScrollHeader;
